module.exports = __webpack_public_path__ + "img/cn-stu-j.290f38d7.png";